import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useHistory } from "react-router-dom";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    "&>h6":{
        fontSize: "1.5rem",
    }
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button:{
    "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)",
    "border":"0px", "borderRadius":"3",
    "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white",
    width: 200,
    marginRight: 15,
    marginBottom: 10,
    textAlign: 'center',
    '@media (max-width:768px)':{ //ipad
        width: '100%',
    },
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
    <Typography variant="h6">{children}</Typography>
    {onClose ? (
      <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
      <CloseIcon />
      </IconButton>
    ) : null}
    </MuiDialogTitle>
  ); 
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

// PROPS
// HANDLECLOSE, OPEN, ESTATUS USUARIO
export default function HasPhoneNumberModal(props) {
  const history = useHistory()

  const closeModalAndBack = () => {
    props.handleClose()
    history.push("/", {})
  }

  return (
    <div>
      <Dialog 
        onClose={() =>closeModalAndBack} 
        aria-labelledby="customized-dialog-title"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        open={props.open}
        maxWidth={"xs"}
        style={{borderRadius: 20}}
      >
        <DialogTitle 
          id="customized-dialog-title" 
          onClose={() =>closeModalAndBack()}
          style={{
            width: '100%',
            fontSize: "1.8rem",
            fontWeight: 600,
            textAlign: 'center',
            color: '#4b4b4b',
          }}
        >
          Estimado usuario
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom style={{
            width: '100%',
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: '27px',
            color: '#545454',
            padding: 18
          }}>
              Hemos detectado que actualmente tu cuenta del Portal Web TSE no tiene asociado un número de celular. <br></br><br></br>
              No te preocupes, presiona el botón "IR A MI PERFIL" y luego busca el icono del lápiz para actualizarlo.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            autoFocus 
            variant='outlined' 
            onClick={()=>{history.push("/PerfilDelUsuario", {})}}
            style={{
              color: "#05A5FF",
              border: `1px solid #05A5FF`
            }}
          >
            IR A MI PERFIL
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
